import moment, { Moment, unitOfTime } from 'moment';

export const DATE_FORMAT = 'DD, MMMM YYYY';

export const MONTH_LIST = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export type DateRange<T extends Moment | Date> = {
  startDate: T;
  endDate: T;
};

export const formatUtcDate = (date: string): string => {
  return moment.utc(date).format(DATE_FORMAT);
};

export const formatUtcTimestamp = (date: string | undefined | null): number => {
  if (!date) return 0;
  return moment.utc(date).unix();
};

export const formatRelativeUtcDate = (date: string) => {
  return moment.utc(date).fromNow();
};

export const formatTimestamp = (date: number) => {
  return moment.unix(date).format(DATE_FORMAT);
};

export const timeDiff = (date: string, unit: unitOfTime.Diff) => {
  return moment().diff(moment.utc(date), unit);
};

export const formatUtcDateWithTimeDiff = (date: string, amount: number, unit: unitOfTime.Diff) => {
  return moment.utc(date).add(amount, unit).format(DATE_FORMAT);
};

export const delay = (miliseconds: number) => {
  return setTimeout(() => {}, miliseconds);
};
